module.exports = __webpack_public_path__ + "static/media/default_fallback_11.40f5df99.png";